import { CloseOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { Col, Modal, Row, Form, Input, Divider, Button, Table, Empty} from "antd"
import {useContext, useEffect, useState} from "react"
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { CategoriaArea } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/saveFile";
import {TemplateContext} from "../../../../utils/template_context";


interface IModalAreasCategorias {
    openModal: boolean;
    setOpenModal: Function,
    isEdit: boolean,
    obtenerAreasCategorias: Function,
    datos: any
    setDatos: Function
}


export const ModalAreasCategorias = ({ openModal, setOpenModal, isEdit, obtenerAreasCategorias, datos }: IModalAreasCategorias) => {
    const context = useContext(TemplateContext);

    const getCategoriasAreas = async() => {
        try {
            const { data } = await apiMaestras.obtenerCategoriasAreas(datos.id_area);
            setAreaCategoria({
                nombre_area: datos.nombre,
                categorias: data,
            })
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        let mounted = true;
        if( mounted ){
            if( isEdit ){
                getCategoriasAreas();
            }
        }
        return () => {
            mounted = false;
        }
    }, [])


    const onCancel = () => {
        setOpenModal(!openModal)
        setAreaCategoria({
            nombre_area: '',
            categorias: [],
        })
    }


    const [areaCategoria, setAreaCategoria] = useState<any>({
        nombre_area: '',
        categorias: [],
    })

    const [categoria, setCategoria] = useState<any>({
        nombre: ''
    })



    const addCategoria = () => {
        if (categoria.nombre !== '') {

            let newArrCategorias = [...areaCategoria.categorias, categoria];

            let hash:any = {};
            newArrCategorias = newArrCategorias.filter((cat) => {
                let exists = !hash[cat.nombre];
                hash[cat.nombre] = true;
                return exists;
            });

            setAreaCategoria({
                ...areaCategoria,
                categorias: newArrCategorias
            })
            setCategoria({
                nombre: ''
            })
        }
    }

    const addCategoriaAsync = async() => {

        if (categoria.nombre !== '') {
            categoria.area_id = datos.id_area;
            try {
                const resp = await apiMaestras.crearCategoriaArea(categoria);
                if(!resp.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: resp.message,
                        placement: "bottomRight",
                      });
                }
                getCategoriasAreas();
                setCategoria({
                    nombre: ''
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const createCategoria = async () => {
        if (areaCategoria.nombre_area == '') {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta el nombre de la linea",
                placement: "bottomRight",
            });
        }

        if (areaCategoria.categorias.length == 0) {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta asociar categorías",
                placement: "bottomRight",
            });
        }

        try {
            let payloadArea = {
                nombre: areaCategoria.nombre_area
            }

            const data = await apiMaestras.crearAreasCategorias(payloadArea);

            if(!data.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: data.message,
                    placement: "bottomRight",
                  });
            }
            let arrayCategorias = areaCategoria.categorias.map((c: any) => {
                return {
                    nombre: c.nombre,
                    area_id: data.data.id_area
                }
            })

            arrayCategorias.forEach(async (categoria: CategoriaArea) => {
               const resp =  await apiMaestras.crearCategoriaArea(categoria)
               //console.log(resp)
               if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
                }
            });

            obtenerAreasCategorias();
            setOpenModal(false);

            setAreaCategoria({
                nombre_area: '',
                categorias: [],
            })
        } catch (error) {
            console.log(error);
        }
    }

    const createCategoriaAsync = async() => {
        if (areaCategoria.nombre_area == '') {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta el nombre de la linea",
                placement: "bottomRight",
            });
        }

        if (areaCategoria.categorias.length == 0) {
            return openNotification({
                titulo: "Error",
                descripcion: "Falta asociar categorías",
                placement: "bottomRight",
            });
        }

        try {

            obtenerAreasCategorias();
            setOpenModal(false);

            setAreaCategoria({
                nombre_area: '',
                categorias: [],
            })
        } catch (error) {
           console.log(error);
        }

    }

    const columns: any = [
        {
            title: "Categoría",
            key: "nombre",
            dataIndex: "nombre",
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: any, record: any, index: number) => (
                <div className="controls">
                    <EditOutlined onClick={() => editCategoria(datos, index)} />
                    <DeleteOutlined onClick={() => {
                        if( isEdit ){
                            deleteCategoriaAsync(datos)
                        } else {
                            deleteCategoria(index)
                        }
                    }}  />
                </div>
            )
        },
    ]

    const [visible, setVisible] = useState(false);
    const [datosCategoria, setDatosCategoria] = useState<any>({});
    const [indexCategoria, setIndexCategoria] = useState(0);
    const editCategoria = (datos: any, index: number) => {
        setDatosCategoria(datos);
        setIndexCategoria(index);
        setVisible(true);
    }


    const [openAlert, setOpenAlert] = useState(false);
    const updateCategoria = () => {
        let newArray = areaCategoria.categorias.map((x : any, index: any) => {
            if (index === indexCategoria) {
                return datosCategoria;
            }

            return x
        })

        setAreaCategoria({
            ...areaCategoria,
            categorias: newArray
        })

        setVisible(false);
        setOpenAlert(true);
    }

    const updateCategoriaAsync = async() => {
        try {
            const resp = await apiMaestras.actualizarCategoriasAreas(datosCategoria);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            getCategoriasAreas();
            setVisible(false);
            setOpenAlert(true);
        } catch (error) {
            console.log(error)
        }
    }

    const deleteCategoria = (index: number) => {
        let newCatgorias = areaCategoria.categorias.filter((x: any, idx: any) => idx !== index);
        setAreaCategoria({
            ...areaCategoria,
            categorias: newCatgorias
        })
    }

    const deleteCategoriaAsync = async(datos: any) => {
       try {
           const resp = await apiMaestras.eliminarCategoriasAreas(datos.id);
           if(!resp.ok){
            return openNotification({
                titulo: "Error",
                descripcion: resp.message,
                placement: "bottomRight",
              });
        }
           getCategoriasAreas();
       } catch (error) {
           console.log(error);
       }
    }



    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar expresión / categoria</div>
                            )
                            :
                            (

                                <div>Crear expresión / categoría</div>
                            )
                        }
                    </>
                }
                width={1000}
                visible={openModal}
                onCancel={onCancel}
                footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button
                                    className="button-blanco-radius"
                                    onClick={onCancel}
                                >
                                    Cancelar
                                </Button>
                            </Col>
                            <Col>
                                <Button
                                    className="button-azul-radius"
                                    onClick={() => {
                                        if(isEdit) {
                                            createCategoriaAsync()
                                        } else {
                                            createCategoria()
                                        }
                                    }}
                                >
                                    Guardar cambios
                                </Button>
                            </Col>
                        </Row>
                }
            >
                <Form

                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre expresión
                            </span>
                            <Form.Item >
                                <Input maxLength={30} value={areaCategoria.nombre_area} onChange={(e) => setAreaCategoria({ ...areaCategoria, nombre_area: e.target.value })} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <div>Crear categorías</div>
                            <Divider />
                        </Col>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre categoría
                            </span>
                            <Form.Item >
                                <Input maxLength={200} value={categoria.nombre} onChange={(e) => setCategoria({ ...categoria, nombre: e.target.value })} />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Row justify="end">
                                <Col>
                                    <Button
                                        onClick={() => {
                                            if( isEdit ){
                                                addCategoriaAsync();
                                            } else {
                                                addCategoria()
                                            }
                                        }}
                                        className="button-blanco-radius"
                                    >
                                        Guardar
                                    </Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>

                {openAlert &&
                    <Row gutter={[24, 24]} style={{ marginBottom: '12px' }} className="alert">
                        <Col className="alert__modal">
                            Se editó con éxito "{datosCategoria.nombre}"
                        </Col>
                        <Col>
                            <CloseOutlined onClick={() => setOpenAlert(false)} />
                        </Col>
                    </Row>
                }

                <Row>
                    <Col>
                        <div>Categorías asociadas</div>
                    </Col>
                    <Col>
                        <Table
                            dataSource={areaCategoria.categorias}
                            columns={columns}
                            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                            style={{ borderTop: "1px solid #C4C4C4" }}
                            size="small"
                            bordered={false}
                            pagination={false}
                        />
                    </Col>
                </Row>
            </Modal>

            {visible &&
                <Modal
                    title="Editar Categoría"
                    visible={visible}
                    footer={
                            <Row justify="end" gutter={[24, 24]}>
                                <Col>
                                    <Button
                                        className="button-blanco-radius"
                                        onClick={onCancel}
                                    >
                                        Cancelar
                                    </Button>
                                </Col>
                                <Col>
                                    <Button
                                        className="button-azul-radius"
                                        onClick={() => {
                                            if( isEdit ) {
                                                updateCategoriaAsync()
                                            } else {
                                                updateCategoria()
                                            }
                                        }}
                                    >
                                        Guardar Cambios
                                    </Button>
                                </Col>
                            </Row>
                    }
                    width={1000}
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre categoría
                            </span>
                            <Form.Item>
                                <Input value={datosCategoria.nombre} onChange={(e) => setDatosCategoria({
                                    ...datosCategoria,
                                    nombre: e.target.value
                                })} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Modal>
            }
        </>
    )
}
